import { render, staticRenderFns } from "./smsSend.vue?vue&type=template&id=c24ab5de&scoped=true"
import script from "./smsSend.vue?vue&type=script&lang=js"
export * from "./smsSend.vue?vue&type=script&lang=js"
import style0 from "./smsSend.vue?vue&type=style&index=0&id=c24ab5de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ab5de",
  null
  
)

export default component.exports